
    import '/Users/lijixiang/Work/power-design/site/docs/mobile/tag-container.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-mobile-tag-container-demo-tag-container"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/mobile/tag-container.md?type=demo')
};